var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { customPaymentMethods } from "@jti/fe-common";
import { getCurrentMagentoClient } from "@jti/magento";
import { OrderExceptionCode } from "../../types/OrderExceptions.types";
export const placeOrderDeclaration = (isFreeTrial) => createAsyncThunk(isFreeTrial ? "freeTrialCheckout/placeOrder" : "checkout/placeOrder", ({ cartId, shippingAddress, additionalAttributes, isZeroValueOrder = false }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    try {
        const orderDetails = yield getCurrentMagentoClient(isFreeTrial).placeOrder(cartId, additionalAttributes, isZeroValueOrder ? customPaymentMethods.zeroValueOrder : undefined);
        if (!orderDetails.orderNumber || !orderDetails.entityId) {
            throw new Error("Order number and/or entity id is missing");
        }
        return Object.assign(Object.assign({}, orderDetails), { shippingAddress });
    }
    catch (error) {
        const errorMessage = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message;
        return rejectWithValue({
            message: errorMessage,
            code: OrderExceptionCode.MagentoOrderCreationIssue,
        });
    }
}));
export const placeOrder = placeOrderDeclaration(false);
export const placeFreeTrialOrder = placeOrderDeclaration(true);
//# sourceMappingURL=placeOrder.js.map